import { NavLink, Outlet } from 'react-router-dom';

const TABS = [
  ['roster', 'Roster & roles'],
  ['approval-flow', 'Workflow'],
  // 'field-rules' is gone from the nav: everything it edited is in Field builder now, its
  // per-field half duplicated there and its firm-wide half as the "Markers & explanations" tab.
  // The route itself still exists and redirects, so old bookmarks are not dead ends.
  ['field-builder', 'Field builder'],
  ['areas-of-law', 'Areas of law & subtypes'],
  ['numbering', 'Numbering'],
  ['conflicts', 'Conflicts'],
  ['pdf-layout', 'PDF layout'],
  ['directories', 'Directories'],
  ['alerts', 'Alerts'],
  ['help-page', 'Help page'],
  ['mail-queue', 'Mail queue'],
  ['orbit', 'Orbit feed'],
];

const tabClass = ({ isActive }) =>
  `border-b-2 px-3 py-2 text-sm ${
    isActive
      ? 'border-firm-700 dark:border-firm-500 font-medium text-firm-700 dark:text-firm-100'
      : 'border-transparent text-slate-600 dark:text-slate-300 hover:text-firm-700 dark:hover:text-firm-100'
  }`;

export default function AdminLayout() {
  return (
    <div className="space-y-4">
      <h1 className="text-xl font-semibold text-firm-700 dark:text-firm-100">Administration</h1>
      <p className="text-sm text-slate-600 dark:text-slate-300">
        Every change made here is written to the global audit log with your name attached.
      </p>
      <nav className="flex gap-1 border-b border-slate-200 dark:border-slate-700">
        {TABS.map(([to, label]) => (
          <NavLink key={to} to={to} className={tabClass}>
            {label}
          </NavLink>
        ))}
      </nav>
      <Outlet />
    </div>
  );
}
